/**
 * Created by Joseph.Saliba on 2/3/16.
 */
import {IServiceProviderFactory} from "angular";

export class Factory {
  public static Create(t: { new(...args) }): IServiceProviderFactory {
    return function (this: any, ...args: any[]) {
      return new (Function.bind.apply(t, [t, ...args]) as any)();
    };
  }
}
